import {BrowserRouter as Router} from 'react-router-dom'
import MainRoute from './MainRoute';
import Public from './Public';
import AuthRoutes from './AuthRoute';
import Protected from './Protected';
import PostLoginRedirect from './PostLoginRedirect';

const BrowserRoute = () => {
  return (
    <>
      <Public>
        <AuthRoutes />
      </Public>
      <Protected>
        <Router>
          <PostLoginRedirect />
          <MainRoute />
        </Router>
      </Protected>
    </>
  );
};

export default BrowserRoute;
